import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getDriver, patchUpdateDriver, postAddDriver } from 'redux/actions/UserDriver';
import DriverBreadCrumb from './DriverBreadCrumb';
import Loader from 'components/loader/Loader';
import CommonTable from 'components/commonTable/CommonTable';
import { filterStatusData, moreIconData } from 'pages/vendor/VendorBreadCrumbData';
import { driverDialogData } from 'pages/vendor/VendorBreadCrumbData';
import { subDriverDialogData } from 'pages/subVendor/SubVendorViewData';
import CommonDialog from 'components/commonDialog/CommonDialog';
import { debounce } from 'lodash';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';
import { getOnBoardCompliance } from "redux/actions/UserCompliance";
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';

function DriverTable() {
  let singleDriverStatus = JSON.parse(localStorage.getItem('singleDriverStatus'))
  const location = useLocation();
  const {state} = useLocation() || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [type, setType] = useState('Edit');
  const [id, setId] = useState(null);
  const [iconType, setIconType] = useState("Edit");
  const userID = localStorage.getItem('ID')
  const companyId = localStorage.getItem('companyId')
  const role = localStorage.getItem('role')
  const [defaultValue, setDefaultValue] = useState({})
  const [iconId, setIconId] = useState(null);
  const tableData = useSelector((state) => state?.userDriver?.userDriver?.data);
  const parentCompany = localStorage.getItem('parentCompany')

  const profileData = useSelector((state) => state?.userProfile?.userProfile?.data);
  const loader = useSelector((state) => state?.userDriver?.loading);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const formData = (role === 'subVendorCompany' ? subDriverDialogData() : driverDialogData)
  const [status, setStatus] = useState(state?.driverStatus ? [state?.driverStatus] : singleDriverStatus?.length > 0 ? singleDriverStatus : "");
  const [search, setSearch] = useState("")
  const [selectedImage, setSelectedImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const filterData = {
    id: state?.companyType === 'adminCompany' ? '' : companyId,
    status:status,
    page:page,
    pageSize:rowsPerPage,
    date:'',
    duration:'',
    type: 'driver',
    search:search
  }

    const onImageChange = (val) => {
    setSelectedImage(val);
  };

  useEffect(() => {
    dispatch(getDriver(filterData));
  }, []);

  const defaultVendor= {
    name:tableData?.body[0]?.vendorName || parentCompany,
    subVendor: profileData?.companyName,
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getDriver({...filterData, page:newPage}));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(getDriver({...filterData, page:0, pageSize:parseInt(event.target.value)}));
  };

  const onClickMoreIcon = (data, type) => {
    const value = {
      driverName: data?.name,
      email: data?.email,
      name: data?.vendorName,
      number: data?.mobile,
      address: data?.address,
      city: data?.city,
      state: data?.state,
      subVendor: data?.subVendorName,
      avtar: selectedImage,
    }
    setDefaultValue(value)
    setId(data.id)
    setIconId(data.id);

    let statusAction = '';
    switch (type) {
      case 'Deactivate':
        statusAction = 'InActive';
        break;
      case 'Activate':
        statusAction = 'Active';
        break;
      case 'Block':
        statusAction = 'Blocked';
        break;
      case 'Unblock':
        statusAction = 'Active';
        break;
      default:
        break;
    }

    if(type === 'Delete'){
      
    }else if(type === 'Edit') {
      setType(type)
      setIconType(type);
      setOpen(true);
    } else if (type === "Upload Compliance") {
          setType(type);
          setIconType(type);
          setOpen(true);
          const profileData = {
            driverId: data.id,
            type: "driverRegistration",
          };
          setShowOtherComponent(true);
          dispatch(getOnBoardCompliance(profileData));
        }
    else if (statusAction !== '') {
      const profileData = {
        driverId: data.id,
        parentId: companyId,
        page:page,
        pageSize:rowsPerPage,
        search:search,
        status: status,
        data: {
          status: statusAction,
        },
      };
      dispatch(patchUpdateDriver(profileData));
    }
  }
 
  const handleClose = () => {
    setShowOtherComponent(false);
    setOpen(false);
  }

  const onClickTableDriver = (val) => {
    localStorage.setItem('singleDriverStatus', JSON.stringify(status))
    const urlParts = location.pathname.split('/')[1];

    if (urlParts === 'driver') {
      navigate(
        '/driver/details', {state:{driverId:val?.id, status:val?.status, name:val?.name, id:val?.authId}}
      );
    }
  };

  const onSearch = debounce((e) =>{
    setPage(0)
    setSearch(e)
    const searchFilterData = {
      ...filterData,search:e, page: 0
    }
    dispatch(getDriver(searchFilterData))
  },1000)
  const onSubmit = (val, code) => {
    const data = {
      mobile: val.number,
      firstName: val.driverName,
      lastName: '',
      altmobile: val.mobile,
      DOB: val.birthday,
      permanentaddress: val.permanentaddress,
      currentaddress: val.currentaddress,
      covid: val.covid,
      email: val.email,
      countryCode: code,
      parentId: companyId,
      companyName: 'abc12121qw' + val.number,
      avtar: selectedImage,
    };
    dispatch(postAddDriver(data));
  }

  const onDialog = (data,code) => {
    const profileData = {
      driverId:id,
      parentId:companyId,
      page:page,
      pageSize:rowsPerPage,
      search:search,
      status:status,
      avtar: selectedImage,
      data:{
        "firstName":data?.driverName,
        "lastName":"",
        "email":data?.email,
        "countryCode":"+91",
        "mobile":data?.number,
        "companyName":"",
        "location":data?.address,
        "name" : data?.vendorName
      }
    }
    dispatch(patchUpdateDriver(profileData));
    setOpen(false);
  }
  
  const onFilterChange = (val) => {
    localStorage.removeItem('singleDriverStatus')
    setPage(0);
    const defaultStatus = ['Active', 'InActive', 'Blocked', 'Pending'];
  
    const filterStatus = val.filter(status => {
      return defaultStatus.includes(status);
    });
  
    setStatus(filterStatus);
  
      const driverFilterData = {
        ...filterData,
        status: filterStatus?.toString(),
        page: 0
      };
      dispatch(getDriver(driverFilterData));
  }
  
  const onRestFilter = () => {
    localStorage.removeItem('singleDriverStatus')
    setStatus("")
    
    const driverFilterData = {
      ...filterData,
      status: ''
    };
    dispatch(getDriver(driverFilterData));
  }

  //roles and permissions 
  const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
  const driverRoleEnum = roleAndPermissionEnum.driver2
  const accessForAdd = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {defaultAllAccess: driverRoleEnum.all, customAccess: driverRoleEnum.add});
  const accessForOnlyView = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorView});
  const accessForOnlyEdit = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorEdit});
  const accessForOnlyActivate = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorActivate});

  const accessForOnlyBlock = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorBlock});

  const accessForOnlyAdd = handlePermissions(roleAndPermissions, driverRoleEnum.moduleKey, {customAccess: driverRoleEnum.subVendorAdd});

  const viewMoreIcon = (accessForAdd || accessForOnlyEdit || accessForOnlyActivate||accessForOnlyBlock )
  const addButton = (accessForAdd ||accessForOnlyAdd )

  return (
    <div>
      <DriverBreadCrumb
        defaultStatus={status} 
        filterdata={filterStatusData} 
        onSubmittBtn={onSubmit}
        defaultValues={defaultVendor} 
        formData={formData}
        onSearch={onSearch}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        companyType={state?.companyType ? state?.companyType : ''}
        addButton={addButton}
      />
    {loader? 
      <Loader/> 
        :
     <CommonTable data={tableData} onClickTableVendor={onClickTableDriver}
     handleChangePage={handleChangePage}
     handleChangeRowsPerPage={handleChangeRowsPerPage}
     page={page}
     rowsPerPage={rowsPerPage}
     isClickable = {true}
    onClickMoreIcon={onClickMoreIcon}
    viewMoreIcon={!viewMoreIcon}
    tabName={"driver"} />
    }
    {open && (iconType === 'Edit' ?
          <CommonDialog
            open={open}
            handleClose={handleClose}
            formData={formData}
            button={'dialogButton'}
            onSubmittBtn={onDialog}
            type={'Edit Driver'}
            selectType={'edit'}
            defaultValues={defaultValue}
          />: 
          <CommonMultiImageForm
                    open={open}
                    handleClose={handleClose}
                    formData={formData}
                    button={"dialogButton"}
                    onSubmittBtn={onDialog}
                    selectType={"edit"}
                    type={'Upload Driver Compliance' }
                    defaultValues={defaultValue}
                    onImageChange={onImageChange}
                    showOtherComponent={showOtherComponent}
                    tabName="driver"
                    vehicleId={iconId}
                    driverId={iconId}
                  />
          )} 
    </div>
  )
}

export default DriverTable;